import { TrophyIcon } from "@phosphor-icons/react";

// Gold "World Series" badge, shown automatically when MLB marks a real game as World Series.
export default function WorldSeriesBadge({ game, compact = false }) {
  const ps = game?.postseason;
  if (!ps?.is_world_series || game.is_demo || String(game.id).endsWith("_demo")) return null;
  const summary = !compact && ps.series_summary;
  return (
    <span
      data-testid={`world-series-badge-${game.id}`}
      title={`${ps.season} World Series${ps.series_summary ? ` — ${ps.series_summary}` : ""}`}
      className="ws-badge relative inline-flex shrink-0 items-center gap-1.5 overflow-hidden rounded px-2 py-0.5 border border-[#E8C15A]/70 bg-gradient-to-r from-[#3a2a06] via-[#5c4310] to-[#3a2a06] text-[#F6D77A] text-[9px] sm:text-[10px] font-black uppercase tracking-[0.14em] whitespace-nowrap shadow-[0_0_14px_-4px_rgba(232,193,90,0.7)]"
    >
      <TrophyIcon weight="fill" size={12} className="text-[#F6D77A] shrink-0" />
      <span data-testid="world-series-badge-title">{ps.season} World Series</span>
      {ps.game_number && (
        <span className="text-[#F6D77A]/70 font-bold" data-testid="world-series-badge-detail">
          Game {ps.game_number}
          {summary && <span className="hidden sm:inline"> · {summary}</span>}
        </span>
      )}
    </span>
  );
}
